import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-commissionrate-dropdown',
  templateUrl: './CommissionRateDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => CommissionRateDropdownComponent)}]
})
export class CommissionRateDropdownComponent extends BaseDropdownComponent {

    
   
    
    constructor() 
    {
        super();
    }


    ngOnInit(): void {
        
    }

    public load(){

       
    }
    
    

}